import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "../../services/apiSlice";
import commonReducer from "../featuresSlice/commonSlice";
import filtersReducer from "../featuresSlice/segmantation";
import objectiveDataAISlice from "../featuresSlice/objectiveDataAI";

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    common: commonReducer,
    filters: filtersReducer,
    objectiveAI: objectiveDataAISlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
});

export default store;
